import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import GrinPopper from 'components/common/menu/GrinPopper'
import { Grid } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import LinkButton from 'components/common/buttons/LinkButton'
import GuidelineCategory from 'components/Patients/PatientGuidelines/GuidelineCategory'
import CategoryItems from 'components/Patients/PatientGuidelines/CategoryItems'

const useStyles = makeStyles(theme => ({
  copilotSettingsTooltip: {
    width: '500px',
    padding: '16px'
  }
}))

/**
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the tooltip is open or not.
 * @param {HTMLElement} props.anchorEl - The element to anchor the tooltip to.
 * @param {CopilotSettingsCategory} props.categoryData - The data for the category.
 * @returns
 */
const CopilotSettingsTooltip = ({ isOpen, anchorEl, categoryData, onViewPatientSettings = () => {} }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <GrinPopper
      customAnchorEl={anchorEl}
      open={isOpen}
      placement="bottom"
      arrowComponent={null}
      className={classes.copilotSettingsTooltip}
    >
      <Grid container direction="column" justifyContent="flex-start" spacing={1} wrap="nowrap">
        <Grid item>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <DazzedParagraph14 bold>
                {t('pages.patients.patientSidebar.items.copilot.copilotSettings.patientSettings.title')}
              </DazzedParagraph14>
            </Grid>
            <Grid item>
              <LinkButton
                label={t('pages.patients.patientSidebar.items.copilot.copilotSettings.patientSettings.button')}
                fontSize={14}
                underline
                onClick={onViewPatientSettings}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <GuidelineCategory icon={categoryData.icon} title={categoryData.title}>
            <CategoryItems
              categoryComponent={categoryData.patientBrief.component}
              items={categoryData.patientBrief.data.items}
              note={categoryData.patientBrief.data.note}
            />
          </GuidelineCategory>
        </Grid>
        {categoryData.practiceGuidelines.component && (
          <>
            <Grid item style={{ marginTop: 20 }}>
              <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                  <DazzedParagraph14 bold>
                    {t('pages.patients.patientSidebar.items.copilot.copilotSettings.practiceSettings.title')}
                  </DazzedParagraph14>
                </Grid>
                <Grid item>
                  <LinkButton
                    label={t('pages.patients.patientSidebar.items.copilot.copilotSettings.practiceSettings.button')}
                    fontSize={14}
                    underline
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <GuidelineCategory icon={categoryData.icon} title={categoryData.title}>
                <CategoryItems
                  categoryComponent={categoryData.practiceGuidelines.component}
                  items={categoryData.practiceGuidelines.data.items}
                  note={categoryData.practiceGuidelines.data.note}
                />
              </GuidelineCategory>
            </Grid>
          </>
        )}
      </Grid>
    </GrinPopper>
  )
}

export default CopilotSettingsTooltip
